import { Component, Input, OnInit } from '@angular/core';

import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { DE_LANGUAGE, EN_LANGUAGE } from '../../../app.constants';
import { BaseComponent } from '../../../core/abstractions/base.component';
import { LanguageService } from '../../../core/services/language.service';
import { UserService } from '../../../core/services/user.service';


@Component({
    selector: 'app-lang-switcher',
    templateUrl: './lang-switcher.component.html',
    styleUrls: ['./lang-switcher.component.scss']
})
export class LangSwitcherComponent extends BaseComponent implements OnInit {

    currentLanguage: string;

    @Input() insideHeader = false;
    @Input() langswitcherPosition: 'left' | 'right' = 'left';
    languages = [DE_LANGUAGE, EN_LANGUAGE];

    isMobile = false;

    constructor(
        private languageService: LanguageService,
        private userService: UserService,
        public responsive: BreakpointObserver
    ) {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();
        this.responsive
            .observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
            .subscribe((state: BreakpointState) => {
                this.isMobile = state.matches;
            });
        this.updateCurrentLanguageWithLoggedUserOrLocalCurrentLanguage();
        this.languageService.languageChangeEmitter.subscribe(() => {
            this.updateCurrentLanguageWithLoggedUserOrLocalCurrentLanguage();
        });
    }

    setLanguage(language: any) {
        this.userService.updateLanguage(language).then(() => {
            this.languageService.changeLanguage(language);
        }).catch(() => {
            this.languageService.changeLanguage(language);
            this.currentLanguage = language;
        });
    }

    getLabel(item: string) {
        return this.hasSmallScreenWidth() ? item : `languages.${item}`;
    }

    hasSmallScreenWidth() {
        return window.outerWidth <= 820;
    }

    updateCurrentLanguageWithLoggedUserOrLocalCurrentLanguage() {
        this.currentLanguage = (this.userService.loggedUser && this.userService.loggedUser.lang) ||
            this.languageService.getLocalCurrentLanguage();
    }

    get activeRoute(): string {
        return this.router.url.split('?')[0];
    }

    addDropdownPanelClass() {
        setTimeout(() => {
            const panel = document.querySelector('.ng-dropdown-panel');
            panel?.classList.add(this.langswitcherPosition);
          }, 0);
    }
}
